export const BASE_PATH = '/admin'

export const LOGIN_PATH = '/login'

export const PROFILE_PATH = '/'
export const SETTINGS_PROFILE_PATH = '/settings/profile'
export const SETTINGS_USER_PATH = '/settings/user'
